import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"display":"flex","gap":"8px","align-items":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "用户ID" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.userId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.userId) = $event)),
                placeholder: "输入用户ID",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "邮箱" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.mobile,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.mobile) = $event)),
                placeholder: "输入邮箱"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "用户名" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.name,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.name) = $event)),
                placeholder: "输入用户名"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "代理" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                placeholder: "请选择代理",
                value: $setup.searchFormState.sysId,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchFormState.sysId) = $event)),
                style: {"min-width":"200px"},
                allowClear: "",
                onPopupScroll: $setup.handleSearchAgentScroll,
                loading: $setup.searchAgentLoading
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, {
                    value: 0,
                    key: "0"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("无")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchAgentList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.id) + " - " + _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onPopupScroll", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.addClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'user.list.add']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 600 }
      }, {
        status: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString(scope.record.status === 1 ? "开启" : "禁用"), 1)
        ]),
        userType: _withCtx(({ scope }) => [
          (scope.record.userType === 1)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 0,
                color: "blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("内部")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_tag, {
                key: 1,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("外部")
                ]),
                _: 1
              }))
        ]),
        businessType: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString(['', '电商', '游戏', '社交', '应用', '其他'][scope.record.businessType] || ''), 1)
        ]),
        serviceAmount: _withCtx(({ scope }) => [
          (
            scope.record.serviceAmount !== null &&
            scope.record.serviceAmount !== undefined &&
            scope.record.serviceAmount !== ''
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.record.serviceAmount) + "% ", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
        ]),
        agent: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString($setup.agentList.find((item) => item.id === scope.record.sysId)?.name || "-"), 1)
        ]),
        control: _withCtx(({ scope }) => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.editClick(scope.record)),
            style: {"margin-right":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("编辑")
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_permission, 'user.list.update']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.topUptoUser(scope.record)),
            style: {"margin-right":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("充值")
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_permission, 'user.list.recharge']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            danger: "",
            size: "small",
            onClick: ($event: any) => ($setup.reBackToUser(scope.record))
          }, {
            default: _withCtx(() => [
              _createTextVNode("退款")
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_permission, 'user.list.recharge']
          ])
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: $setup.isAdd ? '添加' : '编辑',
      visible: $setup.dislogVisible,
      onCancel: _cache[14] || (_cache[14] = ($event: any) => {$setup.dislogVisible = false; $setup.addLoading = false;}),
      onIsDestroyOnClose: _cache[15] || (_cache[15] = ($event: any) => {$setup.addLoading = false;}),
      onConfirm: $setup.confirm,
      loading: $setup.addLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 4, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "用户名",
              name: "name",
              rules: [{ required: true, message: '请输入用户名!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入用户名",
                  value: $setup.formState.name,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.formState.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "公司",
              name: "company",
              rules: [{ required: true, message: '请输入公司名称!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入公司名",
                  value: $setup.formState.company,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.formState.company) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "分类",
              name: "businessType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.formState.businessType,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.formState.businessType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("未填写")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("电商")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("游戏")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("社交")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 4 }, {
                      default: _withCtx(() => [
                        _createTextVNode("应用")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 5 }, {
                      default: _withCtx(() => [
                        _createTextVNode("其他")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "服务费",
              name: "serviceAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  placeholder: "请输入服务费",
                  value: $setup.formState.serviceAmount,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (($setup.formState.serviceAmount) = $event)),
                  min: 0,
                  precision: 2,
                  style: {"width":"100%"},
                  "addon-after": "%"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "邮箱",
              name: "mobile",
              rules: [{ required: true, message: '请输入邮箱!' }],
              extra: "默认密码为邮箱前6位"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入邮箱",
                  disabled: !$setup.isAdd,
                  value: $setup.formState.mobile,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($setup.formState.mobile) = $event))
                }, null, 8, ["disabled", "value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "代理",
              name: "sysId",
              rules: [{ required: true, message: '请选择代理!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "请选择代理",
                  value: $setup.formState.sysId,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (($setup.formState.sysId) = $event)),
                  onPopupScroll: $setup.handleAgentScroll,
                  loading: $setup.agentLoading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, {
                      value: 0,
                      key: "0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("无")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.agentList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.id,
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.id) + " - " + _toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onPopupScroll", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "用户类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  name: "userType",
                  value: $setup.formState.userType,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (($setup.formState.userType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("外部")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("内部")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  name: "isOther",
                  value: $setup.formState.status,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (($setup.formState.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("启用")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("禁用")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "备注",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  placeholder: "请输入备注",
                  value: $setup.formState.remark,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (($setup.formState.remark) = $event)),
                  rows: 3
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "充值",
      visible: $setup.topUpDislogVisible,
      onCancel: _cache[18] || (_cache[18] = ($event: any) => {$setup.topUpDislogVisible = false; $setup.topUpLoading = false;}),
      onIsDestroyOnClose: _cache[19] || (_cache[19] = ($event: any) => {$setup.topUpLoading = false;}),
      onConfirm: $setup.topUpConfirm,
      loading: $setup.topUpLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 4, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "金额",
              name: "wallet",
              rules: [{ required: true, message: '请输入充值金额!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入充值金额",
                  value: $setup.formState.wallet,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (($setup.formState.wallet) = $event)),
                  onInput: $setup.limitAmount,
                  prefix: "$"
                }, null, 8, ["value", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "备注",
              name: "remark2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: $setup.formState.remark2,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (($setup.formState.remark2) = $event)),
                  placeholder: "选填",
                  rows: 3
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "退款",
      visible: $setup.reBackDislogVisible,
      onCancel: _cache[21] || (_cache[21] = ($event: any) => {$setup.reBackDislogVisible = false; $setup.reBackLoading = false;}),
      onIsDestroyOnClose: _cache[22] || (_cache[22] = ($event: any) => {$setup.reBackLoading = false;}),
      onConfirm: $setup.reBackConfirm,
      loading: $setup.reBackLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "reBackFormRef",
          labelCol: { span: 4, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "金额",
              name: "wallet",
              rules: [{ required: true, message: '请输入退款金额!' }]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_input, {
                    placeholder: "请输入退款金额",
                    value: $setup.formState.wallet,
                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (($setup.formState.wallet) = $event)),
                    onInput: $setup.limitAmount,
                    prefix: "$",
                    style: {"flex":"1"}
                  }, null, 8, ["value", "onInput"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: $setup.fillAllAmount
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onConfirm", "loading"])
  ], 64))
}